import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-app-patents-pie-chart',
    templateUrl: './app-patents-pie-chart.component.html',
    styleUrls: ['./app-patents-pie-chart.component.scss']
})
export class AppPatentsPieChartComponent implements OnInit {
    private _patentsData: any;
    get patentsData() {
        return this._patentsData;
    }

    @Input() set patentsData(val: any) {
        this._patentsData = val;
        if (val) {
            this.patentsChart = {
                chart: {
                    toolbar: {
                        show: true
                    },
                    animations: {
                        speed: 400,
                        animateGradually: {
                            enabled: false
                        }
                    },
                    fontFamily: 'inherit',
                    foreColor: 'inherit',
                    height: '100%',
                    type: 'pie',
                    sparkline: {
                        enabled: true
                    }
                },
                dataLabels: {
                    enabled: true,
                    style: {
                        fontSize: '13px',
                        // fontWeight: 'bold',
                    },
                    dropShadow: {enabled: false}
                },
                colors: ['#ceb931', '#edd163'],
                labels: this._patentsData.labels,
                plotOptions: {
                    pie: {
                        customScale: 0.9,
                        expandOnClick: false,
                        donut: {
                            size: '70%'
                        },
                        dataLabels: {
                            offset: -20, style: {
                                textShadow: false
                            }
                        }
                    }
                },
                series: this._patentsData.series.map(p => p.percentageValue),
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        }
                    },
                    active: {
                        filter: {
                            type: 'none'
                        }
                    }
                },
                tooltip: {
                    enabled: true,
                    fillSeriesColor: false,
                    theme: 'dark',
                    custom: ({
                                 seriesIndex,
                                 w
                             }): string => `<div class="flex items-center h-8 min-h-8 max-h-8 px-3">
                                                    <div class="w-3 h-3 rounded-full" style="background-color: ${w.config.colors[seriesIndex]};"></div>
                                                    <div class="ml-2 text-md leading-none">${w.config.labels[seriesIndex]}:</div>
                                                    <div class="ml-2 text-md font-bold leading-none">${w.config.series[seriesIndex]}%</div>
                                                </div>`
                }
            };

        }
    }

    patentsChart: any;

    constructor() {
    }

    ngOnInit(): void {
    }

}
